// extracted by mini-css-extract-plugin
export default {"imageGrid__item":"images_imageGrid__item__OBNyi","cross":"images_cross__IuGjq"};